import config from "../../../Libs/config";
import { API } from "aws-amplify";

export const getQMUserResults = (userId: string) => {
  const apiName = config.apiGateway.QualityMonitoring.NAME;
  const path = `/reviews/${userId}`;
  const myInit = {
    queryStringParameters: {
      userId: userId,
    },
  };

  return API.get(apiName, path, myInit);
};
